import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoadingIndicatorService } from 'src/app/core/services/loading-indicator.service';

@Component({
  selector: 'th-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy {
  showLoadingIndicator = false;

  private showSubscription: Subscription;
  private hideSubscription: Subscription;

  constructor(private loadingIndicatorService: LoadingIndicatorService) {}

  ngOnInit() {
    this.showSubscription = this.loadingIndicatorService.loadingIndicatorChange.subscribe((showLoadingIndicator) => {
      this.showLoadingIndicator = showLoadingIndicator;
    });
  }

  ngOnDestroy() {
    this.showSubscription?.unsubscribe();
    this.hideSubscription?.unsubscribe();
  }
}
